// extracted by mini-css-extract-plugin
export default {"NewsCard":"NewsCard_NewsCard__vrXvp","NewsTitle":"NewsCard_NewsTitle__znEeX"};